export default "__VITE_ASSET__BdtBPww3__"